<template>
  <div class="hawksense-landing">
    <header class="site-header">
      <div class="brand" @click="scrollTo('home')">
        <div class="brand-mark">H</div>
        <div class="brand-text">
          <strong>纳思 HawkSense</strong>
          <span>AI 验布平台</span>
        </div>
      </div>
      <nav class="nav">
        <button
          v-for="item in navItems"
          :key="item.key"
          class="nav-item"
          type="button"
          @click="scrollTo(item.key)"
        >
          {{ item.label }}
        </button>
      </nav>
      <button class="login-btn" type="button" @click="goLogin">
        登录
      </button>
    </header>

    <main class="site-main">
      <section id="home" class="hero">
        <div class="hero-content">
          <p class="hero-kicker">纳思 HawkSense</p>
          <h1>纳思 HawkSense - 重新定义 AI 验布</h1>
          <p class="hero-subtitle">智慧型产业的领导者，科技创新未来</p>
          <button class="cta-btn" type="button" @click="goLogin">
            立即体验智能验布
          </button>
        </div>
        <div class="hero-visual">
          <div class="visual-overlay">
            <p>智能验布机</p>
            <h3>AI 识别界面</h3>
            <ul>
              <li>缺陷检出率 90%+</li>
              <li>最小识别精度 0.2mm²</li>
              <li>边缘计算，低成本部署</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="products" class="section advantages">
        <div class="section-head">
          <p class="section-kicker">Product Advantages</p>
          <h2>产品特点与优势</h2>
        </div>
        <div class="advantage-grid">
          <article class="adv-card">
            <span class="adv-no">01</span>
            <h3>10万+ 超低价</h3>
            <p>采用边缘计算芯片，大幅度降低成本。</p>
          </article>
          <article class="adv-card">
            <span class="adv-no">02</span>
            <h3>90%+ 更精准</h3>
            <p>自研深度学习大模型，识别准确度极高。</p>
          </article>
          <article class="adv-card">
            <span class="adv-no">03</span>
            <h3>60米/分+ 高效率</h3>
            <p>验布速度快，一人可同时操作多台。</p>
          </article>
          <article class="adv-card">
            <span class="adv-no">04</span>
            <h3>OTA 更智能</h3>
            <p>算法支持在线升级，模型市场全面开放。</p>
          </article>
          <article class="adv-card">
            <span class="adv-no">05</span>
            <h3>一键部署 快速上线</h3>
            <p>一体化装置，24小时内即可完成部署。</p>
          </article>
        </div>
      </section>

      <section class="section forms">
        <div class="section-head">
          <p class="section-kicker">Product Forms</p>
          <h2>核心产品与形态</h2>
        </div>
        <div class="form-grid">
          <article class="form-card">
            <div class="form-image">
              <span>加装落地产品</span>
            </div>
            <h3>加装落地产品</h3>
            <p>包含无动力与动力加装两种方案。</p>
          </article>
          <article class="form-card">
            <div class="form-image">
              <span>整机落地产品</span>
            </div>
            <h3>整机落地产品</h3>
            <p>适用于针织、机织面料。</p>
          </article>
          <article class="form-card">
            <div class="form-image">
              <span>机型覆盖</span>
            </div>
            <h3>机型覆盖</h3>
            <p>散对卷机型、卷对散机型、卷对卷机型。</p>
          </article>
        </div>
      </section>

      <section id="benefits" class="section benefits">
        <div class="section-head">
          <p class="section-kicker">Investment Benefits</p>
          <h2>投资效益对比</h2>
        </div>
        <div class="benefit-grid">
          <article class="benefit-card">
            <h3>效率提升</h3>
            <p class="benefit-ai">智能检验机：50-120m/min</p>
            <p class="benefit-human">人工：15-20m/min</p>
            <strong>AI 速度 3 倍以上</strong>
          </article>
          <article class="benefit-card">
            <h3>精度提升</h3>
            <p class="benefit-ai">智能检出率：90%+</p>
            <p class="benefit-human">人工检出率：60-70%</p>
            <strong>精度可达 0.2mm²</strong>
          </article>
          <article class="benefit-card">
            <h3>稳定性</h3>
            <p class="benefit-ai">设备支持 24 小时不间断运行</p>
            <p class="benefit-human">人工依赖高，连续作业能力受限</p>
            <strong>显著降低人力依赖</strong>
          </article>
        </div>
      </section>

      <section id="partners" class="section partners">
        <div class="section-head">
          <p class="section-kicker">Partners</p>
          <h2>行业领先者的共同选择</h2>
        </div>
        <div class="partner-wall">
          <div class="partner-item">福建东龙</div>
          <div class="partner-item">互太纺织</div>
          <div class="partner-item">浙江鑫兰</div>
          <div class="partner-item">致兴纺织</div>
          <div class="partner-item">溢达集团</div>
          <div class="partner-item">SHEIN</div>
        </div>
      </section>
    </main>

    <footer id="about" class="site-footer">
      <div class="footer-row">
        <p>深圳市环思硅纳智慧科技有限公司 / 绍兴环思智慧科技股份有限公司(控股)</p>
      </div>
      <div class="footer-row">
        <p>联系地址：深圳市福田区卓越世纪中心1号楼4704a</p>
        <p>企业邮箱：fish@sinano-ai.com</p>
      </div>
      <div class="footer-row">
        <p>全球布局：绍兴、杭州、上海、广州、越南、孟加拉等</p>
      </div>
      <div class="footer-row footer-copy">
        <p>© 2026 深圳市环思硅纳智慧科技有限公司 版权所有 | 粤ICP备17141449号-2</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data () {
    return {
      navItems: [
        { key: 'home', label: '首页' },
        { key: 'products', label: '产品中心' },
        { key: 'benefits', label: '设备效益' },
        { key: 'partners', label: '合作伙伴' },
        { key: 'about', label: '关于我们' }
      ]
    }
  },
  methods: {
    goLogin () {
      this.$router.push({ name: 'login' })
    },
    scrollTo (id) {
      const target = document.getElementById(id)
      if (!target) return
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
</script>

<style scoped lang="less">
.hawksense-landing {
  height: 100%;
  overflow-y: auto;
  background: linear-gradient(180deg, #f3f8ff 0%, #ffffff 40%, #eef3fb 100%);
  color: #0d1a3a;
}

.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 44px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #dbe7ff;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.brand-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #0b1f5b 0%, #2364e8 100%);
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.brand-text strong {
  font-size: 16px;
}

.brand-text span {
  font-size: 12px;
  color: #4d5b7c;
}

.nav {
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-item {
  border: 0;
  background: transparent;
  color: #11214f;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background: #e9f1ff;
  color: #0b3ea9;
}

.login-btn {
  border: 0;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 600;
  color: #fff;
  background: #0a2e87;
  cursor: pointer;
}

.site-main {
  padding: 26px 44px 56px;
}

.hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  align-items: stretch;
  margin-bottom: 46px;
}

.hero-content {
  padding: 36px 8px 18px 0;
}

.hero-kicker {
  margin: 0 0 14px;
  color: #1f5dde;
  letter-spacing: 0.16em;
  font-weight: 700;
}

.hero-content h1 {
  margin: 0 0 16px;
  font-size: 48px;
  line-height: 1.2;
}

.hero-subtitle {
  margin: 0 0 26px;
  font-size: 18px;
  color: #273a69;
}

.cta-btn {
  border: 0;
  border-radius: 10px;
  padding: 14px 22px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(90deg, #0f3ca0 0%, #1a66ff 100%);
  cursor: pointer;
  box-shadow: 0 10px 28px rgba(15, 60, 160, 0.28);
}

.hero-visual {
  position: relative;
  border-radius: 24px;
  min-height: 420px;
  overflow: hidden;
  background-image: linear-gradient(135deg, rgba(4, 19, 58, 0.8), rgba(18, 67, 168, 0.75)),
    url('~@/assets/images/login-bg.jpg');
  background-size: cover;
  background-position: center;
  box-shadow: 0 30px 60px rgba(13, 26, 58, 0.22);
}

.visual-overlay {
  position: absolute;
  right: 24px;
  bottom: 24px;
  width: 80%;
  max-width: 320px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 16px;
  padding: 20px;
  color: #eaf2ff;
  background: rgba(8, 28, 84, 0.65);
  backdrop-filter: blur(8px);
}

.visual-overlay p {
  margin: 0;
  font-size: 13px;
  color: #9fc2ff;
}

.visual-overlay h3 {
  margin: 8px 0 12px;
  font-size: 22px;
}

.visual-overlay ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.visual-overlay li {
  position: relative;
  padding-left: 14px;
  margin-bottom: 8px;
  font-size: 14px;
}

.visual-overlay li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #59afff;
}

.section {
  margin-bottom: 46px;
}

.section-head {
  margin-bottom: 20px;
}

.section-kicker {
  margin: 0 0 8px;
  color: #2457d0;
  font-size: 13px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.section-head h2 {
  margin: 0;
  font-size: 30px;
}

.advantage-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;
}

.adv-card {
  border-radius: 16px;
  padding: 20px 16px;
  background: #fff;
  border: 1px solid #dce9ff;
  box-shadow: 0 16px 30px rgba(22, 73, 191, 0.08);
}

.adv-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #ecf3ff;
  color: #1f53cb;
  font-weight: 700;
}

.adv-card h3 {
  margin: 12px 0 10px;
  font-size: 18px;
}

.adv-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #33466f;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.form-card {
  border-radius: 18px;
  padding: 14px;
  background: #fff;
  border: 1px solid #dce8ff;
  box-shadow: 0 16px 28px rgba(18, 49, 112, 0.08);
}

.form-image {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 170px;
  color: #e8f2ff;
  font-weight: 700;
  background: linear-gradient(135deg, #122657 0%, #2e6af8 100%);
}

.form-card h3 {
  margin: 12px 0 8px;
  font-size: 18px;
}

.form-card p {
  margin: 0;
  font-size: 14px;
  color: #33466f;
}

.benefit-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.benefit-card {
  border-radius: 16px;
  padding: 18px;
  background: #fff;
  border: 1px solid #dce8ff;
}

.benefit-card h3 {
  margin: 0 0 12px;
  font-size: 20px;
}

.benefit-card p {
  margin: 0 0 8px;
  font-size: 14px;
}

.benefit-ai {
  color: #1256d7;
  font-weight: 600;
}

.benefit-human {
  color: #5f6f90;
}

.benefit-card strong {
  display: block;
  margin-top: 10px;
  font-size: 15px;
}

.partner-wall {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.partner-item {
  border-radius: 12px;
  border: 1px solid #dce8ff;
  background: #fff;
  padding: 16px;
  text-align: center;
  font-weight: 600;
  color: #1f2f57;
}

.site-footer {
  margin: 0 44px 34px;
  border-radius: 16px;
  padding: 24px;
  background: #0b1f5a;
  color: #c9dcff;
}

.footer-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 30px;
  margin-bottom: 10px;
}

.footer-row p {
  margin: 0;
  font-size: 14px;
}

.footer-copy {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(195, 220, 255, 0.24);
}

@media (max-width: 1200px) {
  .advantage-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .benefit-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 900px) {
  .site-header {
    flex-wrap: wrap;
    padding: 14px 18px;
  }

  .site-main {
    padding: 20px 18px 40px;
  }

  .hero {
    grid-template-columns: 1fr;
  }

  .hero-content h1 {
    font-size: 34px;
  }

  .advantage-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .partner-wall {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .site-footer {
    margin: 0 18px 24px;
  }
}

@media (max-width: 560px) {
  .nav {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 4px;
  }

  .nav-item {
    white-space: nowrap;
  }

  .hero-content h1 {
    font-size: 28px;
  }

  .advantage-grid {
    grid-template-columns: 1fr;
  }

  .partner-wall {
    grid-template-columns: 1fr;
  }
}
</style>
